export default {
  features: {
    sellToAlif: {
      desc:
        '"Alif Moliya" MChJ arizada ko‘rsatilgan tovarlarni kelishilgan narxda sotib oladi. "Sotish" tugmasini bosish orqali siz arizada ko‘rsatilgan tovarlarga mulk huquqini "Alif Moliya" MChJga o‘tkazasiz',
      button: 'Sotish',
    },
  },
};
